<template>
  <PageHeader
    title="Tallózó"
    hero-class="bg-gleaner hidden lg:flex"
    :breadcrumb="[ 'Tallózó']"
  >
    <section
      @keyup.enter="$refs.search.submit()"
    >
      <div class="bg-white w-full p-6">
        <client-only>
          <GleanerSearch
            ref="search"
            :query-object="queryObject"
            class="mt-4"
            @searchChanged="searchChanged($event)"
          />
        </client-only>
      </div>

       
      <div 
        ref="entitiesList"
        class="bg-white w-full mt-7"
      >
        <ReOverlayLoader :loading="$fetchState.pending || isLoading">
          <RePagination
            :items="entities"
            :hide-page-selector="true"
            result-title="Cikkek száma"
          />
          <div
            v-if="entities.total === 0"
            class="mt-10"
          >
            <p class="text-center">
              A megadott feltételekkel nem található cikk a tallózóban.
            </p>
          </div>
          <div
            v-else
            class="flex flex-col gap-6 p-4 lg:px-10 lg:pt-10 place-items-center"
          >
            <nuxt-link
              v-for="(item) in entities.data"
              :key="item.id "
              class="group w-full"
              :class="{ 'opacity-30': item.status !== 'active' }"
              :to="'/tallozo/cikk/' + item.id + '/' + item.slug"
            >
              <EntityRow 
                :image="getMainImgObj(item)"
                :hide-box-slot="true"
                image-contain
                has-image-padding
              >
                <template #box>
                  <div class="flex flex-col place-content-center place-items-center w-full h-full p-1 lg:p-6">
                    <span class="block text-lg">{{ dtformat(item.published_at, "YYYY-MM-DD", "YYYY.") }}</span>
                    <span class="block text-lg font-semibold">{{ dtformat(item.published_at, "YYYY-MM-DD", "MMMM") }}</span>
                    <span class="block text-3xl font-semibold">{{ dtformat(item.published_at, "YYYY-MM-DD", "D.") }}</span>
                  </div>
                  <br>
                </template>
                <template #body>
                  <div class="flex flex-row w-full h-full">
                    <div class="flex flex-col w-full justify-center">
                      <p class="font-semibold block">
                        {{ item.uptitle | removeHtml }}
                      </p>
                      <h2 class="font-source-serif-pro text-3xl font-semibold text-red group-hover:text-yellow">
                        {{ item.title }}
                      </h2>
                      <p class="font-semibold block">
                        {{ item.subtitle | removeHtml }}
                      </p>
                      <p class="my-[10px]">
                        {{ item.description }}
                      </p>
                      <div
                        v-if="item.themes_list && item.themes_list.length > 0"
                        class="tags"
                      >
                        <div class="flex">
                          <img
                            src="/img/bookmark_icon.svg"
                            alt=""
                          >
                          <ul class="text-[#A4A4A4]">
                            <li
                              v-for="(item2, index2) in item.themes_list"
                              :key="index2"
                              class="inline hover:text-gray"
                            >
                              <nuxt-link :to="'/tallozo?search=themes.type:' + item2.type">
                                {{ item2.type + (index2 == item.themes_list.length - 1 ? '' : ', ') }}
                              </nuxt-link>
                            </li>
                          </ul>
                        </div>
                        <div class="lg:hidden mt-4">
                          <p>
                            {{ item.source.name }} <br>
                            {{ dtformat(item.published_at, "YYYY-MM-DD", "YYYY. MMMM D.")
                            }} 
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </EntityRow>
            </nuxt-link>
          </div>
        </ReOverlayLoader>
      </div>
    </section>
  </PageHeader>
</template>
<script>
import { cloneDeep } from "lodash";
import GleanerSearch from "~/components/folkradio/searches/GleanerSearch.vue";

const RePagination = () =>
  import("~/components/rxt/recomponent/RePagination.vue");

import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
import EntityRow from '~/components/folkradio/EntityRow.vue'
import scrollMixin from "~/mixins/scroll-fetch"


export default {
  components: {
    GleanerSearch,
    RePagination,
    PageHeader,
    ReOverlayLoader,
    EntityRow
  },
  filters: {
    removeHtml (value) {
      // const div = document.createElement('div')
      // div.innerHTML = value
      // return div.textContent || div.textContent || ''
      return value !== null ? value.replace(/<[^>]*>?/gm, '') : ''
    }
  },
  mixins: [scrollMixin],
  head() {
    return {
      titleTemplate: "Tallózó | Folkrádió",
      meta: [
        { hid: "title", name: "title", content: "Tallózó | Folkrádió" },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: "Tallózó | Folkrádió"
        },
        {
          hid: "description",
          name: "description",
          content:
            "Népzene és néptánc témájú sajtófigyelő: hírek, tudósítások, vélemények. Több mint 17 év sajtójának kereshető archívuma."
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content:
            "Népzene és néptánc témájú sajtófigyelő: hírek, tudósítások, vélemények. Több mint 17 év sajtójának kereshető archívuma."
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: this.$getDomain() + "/tallozo"
        },
        {
          hid: "og:site-name",
          name: "og:site-name",
          property: "og:site-name",
          content: this.$getDomain() + "/tallozo"
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: this.$getDomain() + "/img/meta_default.png"
        }
      ]
    };
  },  
  data() {
    return {
      queryUrl: "/gleaners",
      loading:false
    };
  },
  watch: {
    $route(to, from) {
      this.$store.commit("search/setQueryObject", to.query);
      this.entities = {
        data: []
      }
      this.$fetch()
    }
  },
  async fetch() {
    let queryObject = { limit: 25 };

    queryObject = Object.assign(
      queryObject,
      this.$router.history.current.query
    );

    this.$store.commit("search/setQueryObject", queryObject);

    await this.search();
  },
  methods: {
    dtformat(date, from, to) {
      return this.$moment(date, from).format(to);
    },
    themes() {
      return this.$store.state.gleanerTypes.map(item => {
        return {
          key: this.$unique(),
          value: item.type,
          text: item.type
        };
      });
    },
    //scroll fetch method
    getQueryString(){
      let queryObject = this.queryObject;
      queryObject.sort = "-published_at,-updated_at";
      queryObject.limit = 25;

      this.$store.commit("search/setQueryObject", queryObject);

      return decodeURIComponent(
        this.$createQueryString(queryObject)
      );
    },
    hasMainImg(article) {
      if (article.source && article.source.thumbnail) {
        return true;
      }
      return false;
    },
    getMainImgObj(article) {
      if (article.source && article.source.thumbnail) {
        return article.source.thumbnail;
      }
      return null;
    },
    getMainImg(article) {
      if (article.source && article.source.thumbnail) {
        return article.source.thumbnail.url;
      }
      return "/img/event-default_w240.jpg";
    },
    searchChanged(queryObject) {
      this.$router.push({ query: queryObject });
    }
  }
};
</script>

